export type MixedPaymentAmounts = {
  tipAmount: string;
  giftCardTipAmount: string;
  amount: string;
  giftCardAmount: string;
};

export const calculateMixedPaymentAmounts = ({
  orderBalanceDue,
  giftCardBalance,
  tip,
  isStartATab,
  preauthAmount,
}: {
  orderBalanceDue: number;
  giftCardBalance: number;
  tip: number;
  isStartATab: boolean;
  preauthAmount: number;
}): MixedPaymentAmounts => {
  const balanceDue = orderBalanceDue;
  const balanceMinusGiftcard = balanceDue - giftCardBalance;

  let tipAmount = tip;
  let giftCardTipAmount = 0;
  let amount = balanceMinusGiftcard;
  let giftCardAmount = giftCardBalance;

  if (balanceMinusGiftcard < 0) {
    giftCardAmount = balanceDue;
    amount = 0;

    const remainingGiftCardBalance = giftCardBalance - balanceDue;

    if (remainingGiftCardBalance < tip) {
      giftCardTipAmount = remainingGiftCardBalance;
      tipAmount = tip - giftCardTipAmount;
    } else {
      giftCardTipAmount = tip;
      tipAmount = 0;
    }
  }
  //When the user is on the SaT modal they should be using the greater of the two amounts between the order balance and the default tab amount
  if (isStartATab) {
    amount = preauthAmount;
  }

  return {
    tipAmount: tipAmount.toFixed(2),
    giftCardTipAmount: giftCardTipAmount.toFixed(2),
    amount: amount.toFixed(2),
    giftCardAmount: giftCardAmount.toFixed(2),
  };
};
